import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import SiteLayout from '@/components/SiteLayout';
import Home from '@/pages/Home';
import Gallery from '@/pages/Gallery';
import Commission from '@/pages/Commission';
import OrderConfirmation from '@/pages/OrderConfirmation';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminOrders from '@/pages/admin/AdminOrders';
import AdminOrderDetail from '@/pages/admin/AdminOrderDetail';
import AdminPricing from '@/pages/admin/AdminPricing';
import AdminGallery from '@/pages/admin/AdminGallery';
import RequireAdmin from '@/pages/admin/RequireAdmin';
import { PrivacyPolicy, Terms, OrderPolicy } from '@/pages/Policies';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<SiteLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/commission" element={<Commission />} />
                        <Route path="/order/confirmation" element={<OrderConfirmation />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/order-policy" element={<OrderPolicy />} />
                    </Route>
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={
                            <RequireAdmin>
                                <AdminLayout />
                            </RequireAdmin>
                        }
                    >
                        <Route index element={<Navigate to="/admin/orders" replace />} />
                        <Route path="orders" element={<AdminOrders />} />
                        <Route path="orders/:id" element={<AdminOrderDetail />} />
                        <Route path="pricing" element={<AdminPricing />} />
                        <Route path="gallery" element={<AdminGallery />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster richColors position="bottom-right" />
        </div>
    );
}

export default App;
